import { render } from "./aio-login-captcha.vue?vue&type=template&id=8ecaeff8&scoped=true"
import script from "./aio-login-captcha.vue?vue&type=script&lang=js"
export * from "./aio-login-captcha.vue?vue&type=script&lang=js"

import "./aio-login-captcha.vue?vue&type=style&index=0&id=8ecaeff8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ecaeff8"]])

export default __exports__